module.exports = __webpack_public_path__ + "img/svg/position-1.fa23def039ce503f7be9465d908aef80.svg";